export const DocumentationPagePTBRTranslations = {
  documentationPageHeadDescription:
    'Tire suas dúvidas conosco. Fale com nossos especialistas.',
  documentationPageSubtitle: 'Central de Ajuda',
  documentationPageTitle: 'Tire suas dúvidas sobre nossas funcionalidades',
};
